import { DEFAULT_GC_TIME, DEFAULT_STALE_TIME } from '@/client/constants';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import useGetQueryFn from '../use-get-query-fn';

export interface NotificationType {
  ntypid: number;
  uuid: string;
  ffid: number;
  name: string;
  name_system: string;
  description: string | null;
  category: string | null;
  default_in_app: boolean;
  default_email: boolean;
  default_sms: boolean;
  allow_in_app: boolean;
  allow_email: boolean;
  allow_sms: boolean;
  active: boolean;
  deep_link_pattern: string | null;
  date_added: string | null;
}

type QueryResponse = {
  status: number;
  data: {
    notification_types: NotificationType[];
  };
};

export const createListNotificationTypesKey = (additional: any[] = []) => [
  'list-notification-types',
  ...additional,
];

export const useListNotificationTypesQuery = (additionalProps: { include_inactive?: number } = { include_inactive: 1 }) => {
  const queryFn = useGetQueryFn<QueryResponse>({
    defaultErrorMessage: 'An unexpected error occurred while listing notification types',
    endpoint: `/api/admin/notifications/types`,
  });

  return useQuery({
    queryKey: createListNotificationTypesKey([additionalProps]),
    queryFn: () => queryFn({ ...additionalProps }),
    staleTime: DEFAULT_STALE_TIME,
    gcTime: DEFAULT_GC_TIME,
    placeholderData: keepPreviousData,
  });
};
